import React from 'react';
type SectionHeadingProps = {
  kicker?: string;
  title: React.ReactNode;
  subtitle?: string;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  kicker,
  title,
  subtitle,
  tone = 'light'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className="mx-auto max-w-3xl text-center" data-id="element-65" data-mp="3k06wnu4a0ry9">
      {kicker && <p className={`font-display text-sm font-extrabold uppercase ${isDark ? 'text-gold' : 'text-electric'}`} data-id="element-66" data-mp="3k0f95kwhlv8x">
          {kicker}
        </p>}
      <h2 className={`mt-2 font-display text-[28px] font-black uppercase leading-[1.05] sm:text-4xl lg:text-5xl ${isDark ? 'text-white' : 'text-navy-950'}`} data-id="element-67" data-mp="gjq0ntdcgbgm">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-base leading-relaxed sm:text-lg ${isDark ? 'text-white/80' : 'text-ink/70'}`} data-id="element-68" data-mp="6ru3ckj30pdg">
          {subtitle}
        </p>}
    </div>;
}